import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {push} from 'connected-react-router'
import createPathByFilters from '../../utils/createPathByFilters'
import {rootPathSelector} from '../../selectors'
import trackEvent from '../../../../utils/track-event'
import dictionary from '../../../../dictionary'

/** @param {import('./Categories').CategoriesProps} props */
export default function Categories(props) {
    const dispatch = useDispatch()
    const rootPath = useSelector(rootPathSelector)

    const {
        categories,
        filters,
        filters: {loading: disabled, combine},
        isCustomStore,
    } = props

    const tree = categories.createByValue(combine || rootPath)
    const list = categories.transformToFlatList(tree)
    const selects = list.filter((options) => options.length)

    const handleChange = (e) => {
        const newCombine = `${isCustomStore ? '' : rootPath}${e.target.value}`

        dispatch(
            push({
                pathname: createPathByFilters(filters, {
                    combine: newCombine,
                    subTag: '',
                    page: 1,
                }),
            })
        )

        trackEvent({
            category: 'filter_tovar',
            action: newCombine,
        })
    }

    const getActiveOptionValue = (options) => {
        return (options.filter((option) => option.active)[0] || {url: ''}).url
    }

    return (
        <div className="categories">
            <div className="categories__title">
                {dictionary.store.Select_the_desired_section_or_product}
            </div>
            <div className="categories__content">
                <For each="options" index="key" of={selects}>
                    <div className="b-input-field inline" key={key}>
                        <select
                            className="m-select browser-default"
                            disabled={disabled}
                            value={getActiveOptionValue(options)}
                            onChange={handleChange}
                        >
                            <For each="option" of={options}>
                                <option key={option.title} value={option.url}>
                                    {option.title}
                                </option>
                            </For>
                        </select>
                    </div>
                </For>
            </div>
        </div>
    )
}
